<template>
  <div class="bg-color">
    <header class="heading">
      <img src="@img/img_logo.png" class="logo" />
      <img src="@img/select/img_heading2.png" class="heading-img" />
    </header>
    <!-- 活動流程 -->
    <section class="event-step bg-pink">
      <img
        src="@img/select/p2_section_step.png"
        class="w-100"
        alt="event_step"
      />
    </section>

    <!-- 選擇已購買產品 -->
    <section id="products" class="products">
      <div class="row row-cols-2">
        <div class="col" v-for="product in products" :key="product.id">
          <input
            type="radio"
            name="products"
            :id="`product${product.id}`"
            :value="product.id"
            v-model="cardData.pickedProduct"
            ref="pickedProduct"
            @click="onPickProduct"
            hidden
          />
          <label :for="`product${product.id}`">
            <img
              :src="getSrc(product.image)"
              :alt="product.name"
              :title="product.name"
            />
          </label>
        </div>
      </div>
    </section>

    <!-- 輸入文字 -->
    <section class="content-input bg-pink">
      <div class="wrapper bg-rectangle">
        <div class="input-area">
          <img src="@img/select/p2_content_box.png" />
          <div class="textarea-placeholder">
            <textarea
              class="form-control"
              :rows="maxRows"
              v-model.trim="cardData.content"
              @keydown="onKeyDown"
              ref="content"
            ></textarea>
            <div ref="phText">
              <div v-for="text in defaultContents" :key="text">
                {{ text }}
              </div>
            </div>
          </div>
        </div>
        <div class="preview-area">
          <h3 class="title">預覽畫面</h3>
          <div class="device">
            <img src="@img/select/p2_preview_a.png" class="layer-a" />
            <img
              src="@img/select/p2_preview_b2.jpg"
              class="layer-b"
              ref="previewImg"
            />
            <img src="@img/select/p2_preview_c.png" class="layer-c" />
            <img
              src="@img/select/p2_preview_d1.png"
              class="layer-d"
              ref="previewText"
            />
            <div class="preview" ref="preview">
              <p v-for="num in 6" :key="num - 1">
                {{ contents[num - 1] }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 購買人登錄資料 -->
    <section class="user-info">
      <div
        v-for="input in inputs"
        :key="input.id"
        class="input-box gold-border"
      >
        <input
          class="form-control"
          :type="input.type"
          :name="input.name"
          :placeholder="input.placeholder"
          :ref="input.ref"
          v-model.trim="cardData[input.name]"
        />
      </div>
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="check-privacy"
          v-model="cardData.privacy"
          ref="privacy"
        />
        <label for="check-privacy" class="form-check-label">
          <span>我已閱讀並同意接受</span>
          <router-link to="/privacy" target="_blank"> 隱私權條款 </router-link>
        </label>
      </div>
      <button
        class="btn"
        @click="beforeSubmit('submit')"
        :disabled="isProcessing"
      >
        <img
          src="@img/select/p2_btn_link.png"
          class="w-100"
          alt="link_button"
        />
      </button>
    </section>
  </div>
</template>

<script>
import emailValidator from 'email-validator'
import selectData from '@/assets/selectData.js'
import cardAPI from '../apis/index.js'
import filter from '../utils/filter.js'
import gtagAPI from '../apis/gtag.js'

export default {
  name: 'Select',
  data() {
    return {
      steps: [],
      products: [],
      inputs: [],
      defaultContents: [],
      cardData: {
        pickedProduct: 2,
        content: '',
        name: '',
        phone: '',
        email: '',
        privacy: false,
      },
      maxCols: 7,
      maxRows: 6,
      isProcessing: false,
    }
  },
  computed: {
    contents() {
      const contents = this.cardData.content.split('\n')

      for (let i = 0; i < this.maxRows; i++) {
        // 單行不得超過 7 字，將之後的字元往下一斷推
        const length = contents[i] && contents[i].length
        if (length > this.maxCols) {
          const lastString = contents[i].slice(this.maxCols)
          contents[i] = contents[i].slice(0, this.maxCols)

          const next = i + 1
          if (next === this.maxRows) break
          contents[next] = lastString + (contents[next] || '')
        }
      }

      return contents
    },
  },
  watch: {
    'cardData.content': function(val) {
      const content = val
      const rows = this.contents.length

      // placeholder controller
      if (content.length) {
        this.$refs.phText.classList.add('invisible')
      } else {
        this.$refs.phText.classList.remove('invisible')
      }

      // 過濾 emoji
      const isWhiteList = filter.isWhiteList(content)
      if (!isWhiteList) {
        this.cardData.content = filter.replaceChar(content, '?')
      }

      // 超出行數限制時，補正回最上限
      if (rows > this.maxRows) {
        this.cardData.content = content.replace(/\n\n+([^\n]*)$/, '\n$1')
        this.contents.splice(-1)
      }

      // 使 textarea 與預覽結果同步
      this.cardData.content = this.contents.join('\n')
    },
  },
  beforeRouteEnter(to, from, next) {
    // Index 已進行預讀取
    // 如直接進入此頁, 則預讀取 preview 圖
    const previous = from.name
    next((vm) => {
      if (previous === 'Index') return void 0
      vm.preLoadImage()
    })
  },
  created() {
    this.importData()
  },
  methods: {
    importData() {
      this.steps = selectData.steps
      this.products = selectData.products
      this.inputs = selectData.inputs
      this.defaultContents = selectData.defaultContents
    },
    preLoadImage() {
      for (let i = 1; i <= 4; i++) {
        const previewImg = new Image()
        previewImg.src = this.getSrc(`p2_preview_b${i}.jpg`)

        const previewTextImg = new Image()
        previewTextImg.src = this.getSrc(`p2_preview_d${i}.png`)
      }
    },
    onPickProduct(e) {
      const productId = e.target.id.slice(-1)
      const { previewImg, previewText, preview } = this.$refs

      // change preview image
      previewImg.src = this.getSrc(`p2_preview_b${productId}.jpg`)
      previewText.src = this.getSrc(`p2_preview_d${productId}.png`)

      // change style
      const classEnum = {
        2: ['white'],
        3: ['white', 'right'],
      }

      preview.classList.remove('right', 'white')
      if (classEnum[productId]) {
        preview.classList.add(...classEnum[productId])
      }
    },
    beforeSubmit(label) {
      try {
        this.checkInput()
        this.submit()
        gtagAPI.sendClickEvent(label)
      } catch (e) {
        const target = this.$refs[e.location]

        this.$swal.fire({
          text: e.msg,
          didClose: () => {
            if (e.location === 'pickedProduct') {
              // mobile 端 focus radio 不會捲動, 改用 id tag
              window.location.href = '#products'
            } else {
              const DOM = target[0] || target
              DOM.focus()
            }
          },
        })
      }
    },
    async submit() {
      if (this.isProcessing) return void 0
      this.isProcessing = true

      // format cardData
      const cardData = this.cardData
      const formattedContent = this.contents.join('\n')
      const payload = {
        name: cardData.name,
        email: cardData.email,
        phone: cardData.phone,
        bought_product: [cardData.pickedProduct],
        card_content: formattedContent,
      }

      // post cardData
      try {
        const { data } = await cardAPI.postCard(payload)
        const card_id = data.message?.card_id
        const name = cardData.name
        this.$router.push({ path: 'ar-link', query: { card_id, name } })
      } catch (e) {
        this.isProcessing = false
        const { status, data } = e.response
        if (status === 422) {
          const field = data.email ? 'Email' : ''
          this.$swal.fire(`${field} 不符合格式`)
        } else if (status === 404) {
          this.$swal.fire('活動已結束')
        } else if (status === 502) {
          this.$swal.fire('502 Bad Gateway')
        } else {
          this.$swal.fire(`Error: ${e.message}`)
        }
      }
    },
    checkInput() {
      const { cardData, error, contents } = this

      // check null
      const messageEnum = {
        pickedProduct: '請選擇一個禮盒',
        content: '請輸入心裡話',
        name: '請輸入姓名',
        phone: '請輸入電話',
        email: '請輸入 Email',
        privacy: '請同意隱私權條款',
      }
      Object.entries(cardData).forEach((entry) => {
        const [key, value] = entry
        const msg = messageEnum[key]
        if (!value) throw error(key, msg)
      })

      // check card_content length
      const isOverLength = contents.some((str) => str.length > this.maxCols)
      if (isOverLength) throw error('content', '文字內容超出長度限制')

      // check card_content's bad words
      const isProfane = filter.isProfane(cardData.content)
      if (isProfane) throw error('content', '文字包含不雅內容')

      // check phone format
      const isPhone = /^09\d{8}$/.test(cardData.phone)
      if (!isPhone) throw error('phone', '手機號碼不符合格式')

      // check email format
      const isEmail = emailValidator.validate(cardData.email)
      if (!isEmail) throw error('email', 'Email 不符合格式')
    },
    onKeyDown(e) {
      // 到達限制行數時, 封鎖 Enter 斷行
      const rows = this.contents.length
      if (rows >= this.maxRows && e.key === 'Enter') {
        e.preventDefault()
      }
    },
    error(location, msg) {
      return { location, msg }
    },
    getSrc(name) {
      const image = require.context('@img/select', false, /(\.png|\.jpg)$/)
      return image('./' + name)
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-color {
  background-color: rgb(245, 177, 161);
}

.bg-rectangle {
  background: url('~@img/select/p2_BGLine.png') no-repeat;
  background-size: 100%;
}

textarea::placeholder,
input::placeholder {
  color: rgba(0, 0, 0, 0.3);
}

.heading {
  position: relative;
  z-index: 1;

  .logo {
    width: 15%;
    margin-left: 5%;
    position: absolute;
    top: 0;
  }

  .heading-img {
    width: 100%;
  }
}

.event-step {
  margin: -10% 0;
  padding: 15% 0;

  &.bg-pink {
    background-position-y: 60%;
  }

  img {
    position: relative;
  }
}

.products {
  background: url('~@img/select/p2_section_choose.png') no-repeat;
  background-size: 100%;
  padding: 29% 0 10% 0;
  position: relative;
  z-index: 1;

  .row {
    padding: 0 3%;
    margin: 0;
  }

  .col {
    margin-bottom: 4%;
    padding: 0 2%;
  }

  img {
    width: 100%;
    -webkit-filter: brightness(0.6);
    filter: brightness(0.6);
    -moz-transition: linear 0.2s;
    -o-transition: linear 0.2s;
    -webkit-transition: linear 0.2s;
    -ms-transition: linear 0.2s;
    transition: linear 0.2s;
  }

  input + label {
    padding: 4px;
  }

  input:checked + label {
    background-image: linear-gradient(
      110deg,
      #926820,
      #f6d55e,
      #926920,
      #f6d55e
    );

    img {
      -webkit-filter: brightness(1);
      filter: brightness(1);
    }
  }
}

.content-input {
  margin: -10% 0 -10% 0;

  .wrapper {
    position: relative;
    z-index: 0;
    padding: 15% 0 18% 0;

    .input-area {
      position: relative;

      img {
        width: 100%;
      }

      .textarea-placeholder {
        position: absolute;
        top: 20%;
        left: 10%;
        width: 80%;

        & > div {
          color: rgba(0, 0, 0, 0.4);
          font-size: 1.8rem;
          font-weight: bold;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          padding: 2% 5%;
        }
      }

      textarea {
        resize: none;
        overflow-x: hidden;
        padding: 2% 5%;
        background-color: rgba(255, 255, 255, 0.3);
        border: none;
        font-size: 1.8rem;
        font-weight: bold;
        color: black;

        &:focus {
          box-shadow: 0 0 0 0.3rem rgb(218, 87, 9);
        }
      }
    }

    .preview-area {
      .title {
        text-align: center;
        margin: 4% 0 2% 0;
      }

      .device {
        position: relative;

        .layer-a {
          width: 100%;
        }

        .layer-b,
        .preview {
          width: 55%;
          position: absolute;
          top: 18%;
          left: 22.5%;
        }

        .layer-c {
          width: 100%;
          position: absolute;
          top: 8.65%;
          left: 0;
        }

        .layer-d {
          width: 21%;
          position: absolute;
          bottom: 15%;
          right: 10%;
        }

        .preview {
          padding: 5%;

          p {
            margin: 0;
            min-height: 1.2em;
            font-weight: bold;
            font-size: 1.2rem;
          }
        }

        .right {
          padding-left: 20%;
        }

        .white {
          color: #fff;
        }
      }
    }
  }
}

.user-info {
  position: relative;
  background: url('~@img/select/p2_section_info.png') no-repeat;
  background-size: 100%;
  background-position: bottom;
  padding: 32% 6% 0 6%;
  height: 800px;

  .input-box {
    margin-bottom: 2.5rem;
  }

  .form-control {
    color: black;
    font-size: 2rem;
    font-weight: bold;
    border-radius: 20px;
    padding-left: 1.5rem;

    &:-webkit-autofill::first-line {
      font-size: 2rem;
      font-weight: bold;
    }

    &:focus {
      box-shadow: 0 0 0 0.3rem #3fa6ff;
    }
  }

  .form-check {
    font-size: 1.5rem;
    color: white;
    padding: 0;
    display: flex;
    align-items: center;

    .form-check-input {
      margin: 0 5px 0 0;
      font-size: 2.5rem;
      border-radius: 0;
    }

    a {
      color: white;
      text-decoration: none;
      border-bottom: solid 1px;
      padding: 2px 0;
    }
  }

  .btn {
    display: block;
    margin: 4.5rem auto 0 21%;
    width: 60.5%;
  }
}
</style>
